import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBctwrTyOGUXxkYEVeFNYgRHIHmncUlkdg",
  authDomain: "art-appraisal-1de82.firebaseapp.com",
  projectId: "art-appraisal-1de82",
  storageBucket: "art-appraisal-1de82.firebasestorage.app",
  messagingSenderId: "285197284463",
  appId: "1:285197284463:web:600fb5e6a88204a1f8499a"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
